document.addEventListener("DOMContentLoaded", function () {
  const showcaseSlider = new Swiper(".banner-slider", {
    speed: 1000,
    slidesPerView: 1,
    parallax: true,
    autoplay: {
      delay: 8000,
    },
    direction: "horizontal",
    effect: "fade",
    loop: true,
    speed: 1000,
    pagination: {
      el: ".banner-slider-pagination",
      clickable: true,
    },
    // navigation: {
    //   nextEl: '.banner-slide-next',
    //   prevEl: '.banner-slide-prev',
    // },
  });

  const categoriesSlider = new Swiper(".categories-slider", {
    slidesPerView: 1.3,
    spaceBetween: 15,
    loop: false,
    autoplay: false,
    navigation: false,
    pagination: false,
    breakpoints: {
      768: {
        slidesPerView: 1.5,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 2.5,
        spaceBetween: 25,
      },
      1200: {
        slidesPerView: 3.5,
        spaceBetween: 30,
      },
    },
  });

  new Swiper(".customer_reviews_slider", {
    slidesPerView: 4,
    spaceBetween: 20,
    loop: true,
    freeMode: true,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    speed: 7000,
    grabCursor: true,
    breakpoints: {
      0: {
        slidesPerView: 1.2,
        spaceBetween: 15,
      },
      480: {
        slidesPerView: 1.5,
        spaceBetween: 15,
      },
      768: {
        slidesPerView: 2.5,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1280: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
    },
    navigation: false,
    pagination: false,
  });

  const accordionTriggers = document.querySelectorAll(".accordion-trigger");
  if (accordionTriggers.length) {
    accordionTriggers.forEach((trigger) => {
      trigger.addEventListener("click", function () {
        const currentItem = this.closest(".accordion-item");
        const currentContent = currentItem.querySelector(".accordion-content");

        document.querySelectorAll(".accordion-item.active").forEach((item) => {
          if (item !== currentItem) {
            item.classList.remove("active");
            const content = item.querySelector(".accordion-content");
            content.style.maxHeight = null;
          }
        });

        const isActive = currentItem.classList.contains("active");
        currentItem.classList.toggle("active");

        if (!isActive) {
          currentContent.style.maxHeight = currentContent.scrollHeight + "px";
        } else {
          currentContent.style.maxHeight = null;
        }
      });
    });
  }
});
